module.exports = "https://de18y2hs3hlxs.cloudfront.net/ea0f2244-3733-4462-8521-3c67071db2f1/images/doctors.png?f2c36e418b5725f34aa32f105b6d7e41";